import { useState } from 'react';
import Cardfile from './Cardfile';
import Carddata from './ApiData';
import Navigation from './Navigation';
function Project() {
    let [data, setData] = useState(Carddata);

    function navlist(apidata1) {
        if(apidata1 == "All"){
            setData(Carddata);
            return;
        }
        let updateList = Carddata.filter((item) => {
            return item.catagary === apidata1;
        })

        setData(updateList);
    }
      let uniqlist = [...new Set( Carddata.map((list)=>
      {
        return list.catagary;
      })
      ),"All"]
      let [ navigationlist,setNavigationList ] = useState(uniqlist);
      
    return (
        <>
            <Navigation navlist = {navlist} navigationlist = {navigationlist} />

            <Cardfile item={data} />
        </>
    )
}
export default Project;